import type React from "react";

import {
  NavigationMenu as ShadcnNavigationMenu,
  NavigationMenuList as ShadcnNavigationMenuList,
  NavigationMenuItem as ShadcnNavigationMenuItem,
  NavigationMenuContent as ShadcnNavigationMenuContent,
  NavigationMenuTrigger as ShadcnNavigationMenuTrigger,
  NavigationMenuLink as ShadcnNavigationMenuLink,
  NavigationMenuIndicator as ShadcnNavigationMenuIndicator,
  NavigationMenuViewport as ShadcnNavigationMenuViewport,
} from "src/shadcn/components/navigation-menu";

export { navigationMenuTriggerStyle } from "src/shadcn/components/navigation-menu";

const NavigationMenu = (
  props: React.ComponentProps<typeof ShadcnNavigationMenu>
) => <ShadcnNavigationMenu {...props} />;

const NavigationMenuList = (
  props: React.ComponentProps<typeof ShadcnNavigationMenuList>
) => <ShadcnNavigationMenuList {...props} />;

const NavigationMenuItem = (
  props: React.ComponentProps<typeof ShadcnNavigationMenuItem>
) => <ShadcnNavigationMenuItem {...props} />;

const NavigationMenuContent = (
  props: React.ComponentProps<typeof ShadcnNavigationMenuContent>
) => <ShadcnNavigationMenuContent {...props} />;

const NavigationMenuTrigger = (
  props: React.ComponentProps<typeof ShadcnNavigationMenuTrigger>
) => <ShadcnNavigationMenuTrigger {...props} />;

const NavigationMenuLink = (
  props: React.ComponentProps<typeof ShadcnNavigationMenuLink>
) => <ShadcnNavigationMenuLink {...props} />;

const NavigationMenuIndicator = (
  props: React.ComponentProps<typeof ShadcnNavigationMenuIndicator>
) => <ShadcnNavigationMenuIndicator {...props} />;

const NavigationMenuViewport = (
  props: React.ComponentProps<typeof ShadcnNavigationMenuViewport>
) => <ShadcnNavigationMenuViewport {...props} />;

export {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
  NavigationMenuContent,
  NavigationMenuTrigger,
  NavigationMenuLink,
  NavigationMenuIndicator,
  NavigationMenuViewport,
};
